import script from "./BsddInfoModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./BsddInfoModal.vue?vue&type=script&setup=true&lang=ts"

import "./BsddInfoModal.vue?vue&type=style&index=0&id=72b0d1e4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-72b0d1e4"]])

export default __exports__